import React, { Component } from "react";
import styles from "./style.module.css";

class Prices extends Component {
  render() {
    return (
      <section id="prices" className={styles.section}>
        <div className={styles.container}>
          <header className={styles.header}>
            <h2 className={styles.h2}>Preise</h2>
          </header>

          <div className={styles.grid}>
            {/* Column 1 — Hairdesign & Styling */}
            <div className={styles.col}>
              <h3 className={styles.title}>Hairdesign &amp; Styling</h3>
              
              <div className={styles.subBlock}>
                <h4 className={styles.subTitle}>Damen</h4>
                <div className={styles.priceRowHead}>
                  <span></span>
                  <span className={styles.priceCol}>Junior</span>
                  <span className={styles.priceCol}>Master</span>
                  <span className={styles.priceCol}>Inhaber</span>
                </div>
                <div className={styles.priceRow}>
                  <span className={styles.item}>Haarschnitt &amp; Styling
                    <span className={styles.itemNote}>Beratung · Verwöhnhhaarwäsche · Typgerechter Haarschnitt · Frisurenstyling</span>
                  </span>
                  <span className={styles.price} data-label="Junior">90,-</span>
                  <span className={styles.price} data-label="Master">95,-</span>
                  <span className={styles.price} data-label="Inhaber">100,-</span>
                </div>
                <div className={styles.priceRow}>
                  <span className={styles.item}>Styling
                    <span className={styles.itemNote}>Beratung · Verwöhnhhaarwäsche · Frisurenstyling</span>
                  </span>
                  <span className={styles.price} data-label="Junior">50,-</span>
                  <span className={styles.price} data-label="Master">55,-</span>
                  <span className={styles.price} data-label="Inhaber">60,-</span>
                </div>
                <div className={styles.priceRowWide}>
                  <span className={styles.item}>Keratinglättung</span>
                  <span className={styles.priceWideValue}>ab 290,-</span>
                </div>
                <div className={styles.priceRowWide}>
                  <span className={styles.item}>Haarverdichtung / Haarverlängerung
                    <span className={styles.itemNote}>mit Great Lengths Echthaarsträhnen (kostenlose Beratung)</span>
                  </span>
                  <span className={styles.priceWideValue}>Preise auf Anfrage</span>
                </div>
              </div>

              <div className={styles.subBlock}>
                <h4 className={styles.subTitle}>Herren</h4>
                <div className={styles.priceRow}>
                  <span className={styles.item}>Herrenpaket Basic
                    <span className={styles.itemNote}>Haarwäsche · Typgerechter Haarschnitt · Finish</span>
                  </span>
                  <span className={styles.price} data-label="Junior">60,-</span>
                  <span className={styles.price} data-label="Master">65,-</span>
                  <span className={styles.price} data-label="Inhaber">70,-</span>
                </div>
                <div className={styles.priceRowWide}>
                  <span className={styles.item}>Grauhaarbedeckung
                    <span className={styles.itemNote}>Grauanteil-Pigmentierung</span>
                  </span>
                  <span className={styles.priceWideValue}>50,-</span>
                </div>
              </div>

              <div className={styles.subBlock}>
                <h4 className={styles.subTitle}>Kinder</h4>
                <div className={styles.priceRowWide}>
                  <span className={styles.item}>Haarschnitt</span>
                  <span className={styles.priceWideValue}>40,-</span>
                </div>
              </div>
            </div>

            {/* Column 2 — Colour Treatments */}
            <div className={styles.col}>
              <h3 className={styles.title}>Colour Treatments</h3>
              
              <div className={styles.subBlock}>
                <h4 className={styles.subTitle}>Coloration</h4>
                <p className={styles.miniText}>Individuelle Farbtonberatung · Sanfte und haltbare Colorationen · Spezielle Farbversiegelung</p>
                <div className={styles.priceRowHead}>
                  <span></span>
                  <span className={styles.priceCol}>Junior</span>
                  <span className={styles.priceCol}>Master</span>
                  <span className={styles.priceCol}>Inhaber</span>
                </div>
                <div className={styles.priceRow}>
                  <span className={styles.item}>Coloration Ansatz</span>
                  <span className={styles.price} data-label="Junior">75,-</span>
                  <span className={styles.price} data-label="Master">80,-</span>
                  <span className={styles.price} data-label="Inhaber">85,-</span>
                </div>
                <div className={styles.priceRow}>
                  <span className={styles.item}>Coloration Ansatz &amp; Längen</span>
                  <span className={styles.price} data-label="Junior">145,-</span>
                  <span className={styles.price} data-label="Master">150,-</span>
                  <span className={styles.price} data-label="Inhaber">155,-</span>
                </div>
                <div className={styles.priceRowWide}>
                  <span className={styles.item}>Glossing</span>
                  <span className={styles.priceWideValue}>ab 70,-</span>
                </div>
              </div>

              <div className={styles.subBlock}>
                <h4 className={styles.subTitle}>Strähnen / Balayage / Foliage</h4>
                <p className={styles.miniText}>Individuelle Farbtonberatung · Kreative Colour &amp; Folien Techniken · Spezielle Farbversiegelung</p>
                <div className={styles.priceRow}>
                  <span className={styles.item}>Halber Kopf</span>
                  <span className={styles.price} data-label="Junior">100,-</span>
                  <span className={styles.price} data-label="Master">105,-</span>
                  <span className={styles.price} data-label="Inhaber">110,-</span>
                </div>
                <div className={styles.priceRow}>
                  <span className={styles.item}>Ganzer Kopf</span>
                  <span className={styles.price} data-label="Junior">130,-</span>
                  <span className={styles.price} data-label="Master">135,-</span>
                  <span className={styles.price} data-label="Inhaber">140,-</span>
                </div>
              </div>
            </div>

            {/* Column 3 — Hair Spa + Beauty */}
            <div className={styles.col}>
              <h3 className={styles.title}>Hair Spa Treatments</h3>
              
              <div className={styles.subBlock}>
                <h4 className={styles.subTitle}>Haarpflege</h4>
                <div className={styles.priceRowWide}>
                  <span className={styles.item}>Intensivhaarpflege
                    <span className={styles.itemNote}>Pflege zur Regeneration der Haarstruktur, für mehr Glanz und Frisierbarkeit</span>
                  </span>
                  <span className={styles.priceWideValue}>15,-</span>
                </div>
                <div className={styles.priceRowWide}>
                  <span className={styles.item}>Expert Treatment
                    <span className={styles.itemNote}>Pflege &amp; Erneuerung der inneren Haarstruktur, –für kraftvolle Elastizität, geschmeidige Fülle &amp; maximalen Glanz <br/>— 2 Phasen Intensivhaarpflege</span>
                  </span>
                  <span className={styles.priceWideValue}>49,-</span>
                </div>
              </div>

              <div className={styles.subBlock}>
                <h4 className={styles.subTitle}>Beauty Treatments</h4>
                <div className={styles.priceRowWide}>
                  <span className={styles.item}>Augenbrauen – Farbe &amp; Design</span>
                  <span className={styles.priceWideValue}>15,-</span>
                </div>
                <div className={styles.priceRowWide}>
                  <span className={styles.item}>Wimpernfärben</span>
                  <span className={styles.priceWideValue}>15,-</span>
                </div>
              </div>

              <p className={styles.disclaimerSmall}>
                Auszug aus unserer Preisliste in €. Die angegebenen Preise sind Grundpreise, die von einem durchschnittlichen Aufwand ausgehen. Bei höherem Aufwand erhalten Sie ein separates Angebot.
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Prices;